var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-audio-recorder",class:{
    'active': _vm.isRecording,
    'paused': _vm.isPaused
  },on:{"mousedown":_vm.switchRecording,"touchstart":_vm.switchRecording}},[_c('i',{class:{
      'ni ni-button-pause': _vm.isRecording},staticStyle:{"font-size":"1.5rem","color":"#fff","padding":"1.1rem"}}),(!_vm.isRecording)?_c('span'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }